import { Progress } from '@/domains';
import { authorizedApi } from '@/services/network/authorized-api';

export const createProgress = (progress: Omit<Progress, 'createdAt'>) => {
  return authorizedApi.post<void>('/v1/progress', { content: [progress] });
};
